import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import type { ReactNode } from 'react';

interface SheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function Sheet({ isOpen, onClose, title, children }: SheetProps) {
  return (
    <Transition show={isOpen}>
      <Dialog className="relative z-[120]" onClose={onClose}>
        <TransitionChild
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/70" />
        </TransitionChild>

        <div className="fixed inset-0 flex justify-end">
          <TransitionChild
            enter="transform transition duration-220"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transform transition duration-180"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <DialogPanel className="h-full w-[88vw] max-w-[360px] border-l border-[rgba(212,175,55,0.25)] bg-[#0a0a0a]/95 p-4 shadow-[0_10px_40px_rgba(0,0,0,0.6)] backdrop-blur-2xl">
              <div className="mb-4 flex items-center justify-between">
                <h2 className="gradient-text font-cinzel text-lg">{title}</h2>
                <button
                  onClick={onClose}
                  className="rounded-lg border border-[rgba(212,175,55,0.3)] bg-[rgba(212,175,55,0.06)] px-3 py-1 font-cinzel text-xs uppercase tracking-[0.1em] text-[#d4af37] transition-colors hover:bg-[rgba(212,175,55,0.12)]"
                >
                  Close
                </button>
              </div>
              <div className="h-[calc(100%-56px)] overflow-y-auto pr-1">{children}</div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
